import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'
import { completedReviewsUrl } from 'modules/performance_process/lib/urls'

export const ReviewEvaluationTaskDefinition: TaskDefinition<'PerformanceReviewEvaluationAnswer'> = {
  taskableTypename: 'PerformanceReviewEvaluationAnswer',
  getUrl: ({ info, navigation, groupedCount }) => {
    const reviewProcessId = info.reviewProcess?.id
    const reviewEvaluationAnswerId = info.id

    if (!reviewProcessId || !reviewEvaluationAnswerId) {
      return null
    }

    if (groupedCount && groupedCount > 1) {
      return completedReviewsUrl(navigation, reviewProcessId)
    }

    return navigation.performanceProcess.reviews.review.completedReviews.fullPath({
      reviewId: reviewProcessId,
      evaluationId: reviewEvaluationAnswerId,
    })
  },
  getTitle: ({ groupedCount, affecteeName, shortVersion }) => {
    if (groupedCount && groupedCount > 1) {
      if (shortVersion) {
        return i18n.t('tasks.inbox.titles.review_evaluation_grouped_short', {
          count: groupedCount,
        })
      }
      return i18n.t('tasks.inbox.titles.review_evaluation_grouped', {
        affecteeName,
        count: groupedCount - 1,
      })
    }

    return i18n.t('tasks.inbox.titles.review_evaluation', {
      affecteeName,
    })
  },
  getMetadata: ({ info }) => {
    return [info.reviewProcess?.name ?? '']
  },
}
